import React, { Component } from "react";
import Banner from "../components/banner";
import Intro from "../components/intro";
import Live from "../components/live";
import Invitation from "../components/Invitation";
import Review from "../components/review";
import SideLights from "../components/sideLights";
import Product from "../components/product";
import Experience from "../components/experience";
import PendantBg from "../components/pendantBg";
import { getPageData } from "../assets/js/getData";

export default class Page extends Component {
  constructor(props) {
    super(props);
    this.state = { init: false, mainHeight: 0 };
  }
  render() {
    let {
      init,
      banner,
      actAddress,
      PCliveAddress,
      productAddress,
      invitation,
      review,
      experience,
      sidelightsBg,
      sidelights,
    } = this.state;
    let { mainHeight } = this.state;
    let { routeName, meta } = this.props;
    return (
      !!init && (
        <div id="main" style={{ position: "relative" }}>
          <div style={{ position: "relative", zIndex: 2 }}>
            <Banner meta={meta} cover={banner} />
            <Intro meta={meta} actAddress={actAddress} />
            <Live meta={meta} liveAddress={PCliveAddress} />
            {meta?.is2021 ? (
              <>
                <Invitation
                  meta={meta}
                  routeName={routeName}
                  list={invitation}
                />
                <Product
                  meta={meta}
                  routeName={routeName}
                  productAddress={productAddress}
                />
              </>
            ) : (
              <>
                <Product
                  routeName={routeName}
                  productAddress={productAddress}
                />
                <Invitation routeName={routeName} list={invitation} />
              </>
            )}
            <Review list={review} />
            <Experience meta={meta} list={experience} />
            <SideLights
              meta={meta}
              routeName={routeName}
              list={sidelights}
              sidelightsBg={sidelightsBg}
            />
          </div>
          {!meta?.is2021 && (
            <>
              {mainHeight > 468 && (
                <PendantBg
                  width="602"
                  top="468"
                  left="659"
                  url={require("../assets/imgs/pendant/bg1.png")}
                />
              )}
              {mainHeight > 1309 && (
                <PendantBg
                  width="283"
                  top="1309"
                  left="-179"
                  url={require("../assets/imgs/pendant/bg2.png")}
                />
              )}
              {mainHeight > 3300 && (
                <PendantBg
                  width="353"
                  bottom="412"
                  left="905"
                  url={require("../assets/imgs/pendant/bg3.png")}
                />
              )}
            </>
          )}
        </div>
      )
    );
  }
  componentDidMount() {
    getPageData(this.props.routeCity).then((data) => {
      this.setState({
        init: true,
        ...data,
      });
      this.setState({
        mainHeight: document.querySelector("#main").offsetHeight,
      });
      window.scrollTo({
        top: 0,
        behavior: "instant",
      });
    });
  }
}
